import { type FC, useCallback } from "react";

import { Button } from "@snapchat/snap-design-system";

import { type MyLensesLens } from "../../../../gql-generated/types";
import { Flexbox } from "../../../../shared/components";
import { type LensModalProps } from "../../../models";
import { modalTriggerLinkButtonStyle } from "../lens-submission-errors";
import { ModalTriggerText } from "../lens-submission-errors/messages.generated";

interface LensRowSubmissionErrorModalTriggerProps {
    lens: MyLensesLens;
    submissionErrorsProps: LensModalProps;
    className?: string;
}

export const LensRowSubmissionErrorModalTrigger: FC<LensRowSubmissionErrorModalTriggerProps> = ({
    lens,
    submissionErrorsProps: { showModal, setLens },
    className,
}) => {
    const onSubmissionErrorClick = useCallback(() => {
        setLens(lens);
        showModal();
    }, [lens, showModal, setLens]);

    return (
        <Flexbox justifyContent="center" className={className}>
            <Button
                data-testid="submission-errors-modal-trigger"
                onClick={onSubmissionErrorClick}
                type="link"
                className={modalTriggerLinkButtonStyle}
            >
                <ModalTriggerText />
            </Button>
        </Flexbox>
    );
};
